function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.393 9.397c0 1.84-1.53 3.334-3.418 3.334-1.887 0-3.418-1.493-3.418-3.334 0-1.842 1.53-3.334 3.418-3.334 1.888 0 3.418 1.492 3.418 3.334zm-1.367 0c0 1.104-.918 2-2.05 2-1.133 0-2.052-.896-2.052-2 0-1.105.919-2 2.051-2 1.133 0 2.05.895 2.05 2z",
    style: {
      strokeWidth: 0.90016
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.265 1.793c0-.95.79-1.731 1.764-1.731h1.892c.975 0 1.764.78 1.764 1.731 0 1.316 1.463 2.153 2.628 1.491.839-.476 1.915-.195 2.397.627l.962 1.639a1.706 1.706 0 0 1-.647 2.353 1.708 1.708 0 0 0 0 2.988 1.706 1.706 0 0 1 .647 2.352l-.962 1.64c-.482.821-1.558 1.103-2.397.626-1.165-.662-2.628.176-2.628 1.491 0 .95-.79 1.731-1.764 1.731h-1.892c-.974 0-1.764-.78-1.764-1.731 0-1.315-1.462-2.153-2.628-1.49-.838.476-1.914.194-2.397-.627l-.961-1.64a1.706 1.706 0 0 1 .646-2.352 1.708 1.708 0 0 0 0-2.988A1.706 1.706 0 0 1 3.28 5.55l.961-1.64c.483-.82 1.559-1.102 2.397-.626 1.166.662 2.628-.175 2.628-1.49Zm1.764-.397h1.892c.209 0 .397.173.397.397 0 2.32 2.586 3.835 4.683 2.644a.386.386 0 0 1 .522.136l.962 1.64a.39.39 0 0 1-.148.537 3.025 3.025 0 0 0 0 5.293.39.39 0 0 1 .148.538l-.962 1.64a.386.386 0 0 1-.522.136c-2.097-1.192-4.683.323-4.683 2.643a.401.401 0 0 1-.397.398h-1.892a.401.401 0 0 1-.397-.398c0-2.32-2.585-3.835-4.683-2.643a.386.386 0 0 1-.522-.137l-.962-1.639a.39.39 0 0 1 .148-.538 3.025 3.025 0 0 0 0-5.293.39.39 0 0 1-.148-.538l.962-1.639a.386.386 0 0 1 .522-.136c2.098 1.191 4.683-.323 4.683-2.644 0-.224.189-.397.397-.397z",
    style: {
      strokeWidth: 0.90016
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "5.33333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    x: 0.207,
    y: 23.746
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.207,
    y: 23.746,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "5.33333px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, "CONFIG")));
};
export default SvgGear;